import { Dispatch } from 'redux';
import { actionCreators } from './ConfigSettingsState';
import { CategoryCountRequest } from '../../../Interfaces/Assets/CategoryCountRequest';
import { UpdateConfigSetting } from '../../../Interfaces/Config/ConfigSetting';
import { ApiEnums } from '../../../Interfaces/ApiEnums';

export const resetAssetsState = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.resetState());
};

export const getConfigSettingsByNodeUuid = async (
  dispatch: Dispatch<any>,
  uuid: string,
) => {
  return dispatch(actionCreators.getConfigSettingsByNodeUuid(uuid));
};

export const exportFilteredAssetsConfig = async (
  dispatch: Dispatch<any>,
  configType: ApiEnums.ConfigSettingsType,
) => {
  return dispatch(actionCreators.exportFilteredAssets(configType));
};

export const getAllNodesConfigByPage = async (
  dispatch: Dispatch<any>,
  configType: ApiEnums.ConfigSettingsType,
) => {
  return dispatch(actionCreators.getNodesByPage(configType));
};

export const resetNodesResult = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.resetNodesResult());
};

export const getNodeConfigCategoryList = async (
  dispatch: any,
  configType: ApiEnums.ConfigSettingsType,
) => {
  return dispatch(actionCreators.getNodeConfigCategoryList(configType));
};

export const getNodeConfigAssetNameList = async (
  dispatch: any,
  configType: ApiEnums.ConfigSettingsType,
  assetCategory: string,
) => {
  return dispatch(actionCreators.getAssetNameList(configType, assetCategory));
};

export const resetFilteredAssets = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.resetFilteredAssets());
};

export const clearEditConfigSettings = async (dispatch: any) => {
  return dispatch(actionCreators.clearEditConfigSettings());
};

export const editConfigSettings = async (
  dispatch: any,
  configType: ApiEnums.ConfigSettingsType,
  updateConfigSetting: UpdateConfigSetting,
) => {
  return dispatch(
    actionCreators.editConfigSettings(configType, updateConfigSetting),
  );
};

export const fetchConfigNodeImage = async (dispatch: any, uuid: string) => {
  return dispatch(actionCreators.fetchConfigNodeImage(uuid));
};

export const resetFetchError = async (dispatch: any) => {
  return dispatch(actionCreators.resetFetchError());
};

export const getConfigFeatures = async (dispatch: any) => {
  return dispatch(actionCreators.getConfigFeatures());
};

export const fetchFeatureFileFolderPath = async (dispatch: any) => {
  return dispatch(actionCreators.fetchFeatureFileFolderPath());
};

export const uploadFileToServer = async (
  dispatch: any,
  serverPath: string,
  data: any,
) => {
  return dispatch(actionCreators.uploadFileToServer(serverPath, data));
};

export const getConfigValues = async (
  dispatch: Dispatch<any>,
  configType: ApiEnums.ConfigSettingsType,
  categoryCountRequest: CategoryCountRequest,
) => {
  return dispatch(
    actionCreators.getConfigValues(configType, categoryCountRequest),
  );
};
